/**
 * NOTCH: Sticky cart by Notch — earlier reveal for the core sticky cart block.
 * Shows sticky cart when the main Add to cart button scrolls above the viewport.
 */
(function () {
  var INIT_ATTR = 'data-notch-sticky-cart-init';

  function getConfig() {
    if (window.NotchStickyCartConfig) {
      return window.NotchStickyCartConfig;
    }
    return { enabled: true, offset: 0 };
  }

  function noop() {}

  function shouldShowSticky(entry) {
    return !entry.isIntersecting && entry.boundingClientRect.top < 0;
  }

  function teardown(wrapper) {
    if (!wrapper || wrapper.getAttribute(INIT_ATTR) !== 'true') return;

    if (wrapper._notchStickyObserver) {
      wrapper._notchStickyObserver.disconnect();
      wrapper._notchStickyObserver = null;
    }

    wrapper.removeAttribute(INIT_ATTR);
    wrapper.removeAttribute('animate');
  }

  function findMainAtcButton(wrapper) {
    var scope = wrapper.closest('product-info') || wrapper.closest('section') || document;
    return scope.querySelector('product-form.product-form .product-form__submit');
  }

  function initStickyCartEnhancer(config) {
    if (!config || config.enabled === false) return;

    customElements.whenDefined('animate-sticky').then(function () {
      var wrapper = document.querySelector('animate-sticky.sticky-cart-wrapper');
      if (!wrapper) return;

      teardown(wrapper);
      wrapper.setAttribute(INIT_ATTR, 'true');

      wrapper.reveal = noop;
      wrapper.reset = noop;
      wrapper.removeAttribute('animate');

      var atcButton = findMainAtcButton(wrapper);
      if (!atcButton) return;

      var offset = Number(config.offset) || 0;
      var rootMargin = offset + 'px 0px 0px 0px';

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (shouldShowSticky(entry)) {
              wrapper.setAttribute('animate', '');
            } else {
              wrapper.removeAttribute('animate');
            }
          });
        },
        {
          root: null,
          rootMargin: rootMargin,
          threshold: 0
        }
      );

      wrapper._notchStickyObserver = observer;
      observer.observe(atcButton);
    });
  }

  function boot() {
    initStickyCartEnhancer(getConfig());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:unload', function () {
    var wrappers = document.querySelectorAll('animate-sticky.sticky-cart-wrapper[' + INIT_ATTR + '="true"]');
    wrappers.forEach(teardown);
  });
})();
